export const API_PATH_ApiTrafficStudyCommentPut = '/services/traffic-studies/apiTrafficStudyCommentPut';
